import { Entreprise } from '../../intervenant/models/entreprise.model';
import { Utilisateur } from '../../intervenant/models/utilisateur.model';

export class SuiviInventaireVergerModel {
    static jsonMap = {
        idDeclaration: { key: 'idDeclaration', optional: true },
        idEntreprise: { key: 'idEntreprise', optional: true },
        dateDerniereMaj: { key: 'dateDerniereMaj', optional: true },
        dateDerniereValidation: { key: 'dateDerniereValidation', optional: true },
        idAuteurDerniereValidation: { key: 'idAuteurDerniereValidation', optional: true },
        surfacePomme: { key: 'surfacePomme', optional: true },
        surfacePoire: { key: 'surfacePoire', optional: true },
        estAdherentAnpp: { key: 'estAdherentAnpp', optional: true },
        terroir: { key: 'terroir', optional: true, default: '' },
        ct: { key: 'ct', optional: true },
        typeEntreprise: { key: 'typeEntreprise', optional: true, default: '' }
    };

    idDeclaration: number = undefined;
    idEntreprise: number;
    entreprise: Entreprise;
    dateDerniereMaj: Date;
    dateDerniereValidation: Date;
    idAuteurDerniereValidation: number;
    auteurModification: Utilisateur;
    surfacePomme: number;
    surfacePoire: number;
    estAdherentAnpp: boolean;
    terroir: string;
    ct: Utilisateur;
    typeEntreprise: string;
    estValide: boolean;
    public estCochee = false;
}
